import React, { useEffect, useState } from 'react';
import { styled } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const SEPARATOR = ':';
const SECONDS_COUNTDOWN = 60;

export const Countdown = () => {
	const [startTime, setStartTime] = useState<number>(Date.now());
	const [count, setCount] = useState<number>(0);

	useEffect(() => {
		function update() {
			const elapsed = Math.floor((Date.now() - startTime) / 1000);
			if (elapsed >= SECONDS_COUNTDOWN) {
				setStartTime(Date.now());
				setCount(0);
			} else {
				setCount(elapsed % SECONDS_COUNTDOWN);
			}
		}

		const interval = setInterval(update, 100);

		return () => clearInterval(interval);
	}, [setCount, setStartTime, startTime]);

	const minutes = Math.floor(count / SECONDS_COUNTDOWN);

	return (
		<VideoPlayerText>
			{minutes}
			{SEPARATOR}
			{count.toFixed(0).padStart(2, '0')}
		</VideoPlayerText>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const VideoPlayerText = styled.p({
	fontVariantNumeric: 'tabular-nums',
	fontSize: '1.25rem',
	fontWeight: 500,
	paddingRight: token('space.400', '32px'),
	paddingTop: token('space.100', '8px'),
	paddingBottom: token('space.100', '8px'),
	fontFamily: 'Monospace',
	lineHeight: '24px',
	margin: 0,
	borderRight: `0.075em solid ${token('color.border', 'rgba(9, 30, 66, 0.14)')}`,
});
